import { NEW_LORRY_CAPACITY } from "@vahak/core/dist/constants/lorryTypes";

export type LorryVehicleRestrictionKind = "three_wheeler" | "capacity_out_of_range";

export interface LorryVehicleRestrictionInput {
    capacity?: number | null;
    totalTyres?: number | null;
    vehicleCategory?: string | null;
}

export interface CapacityBounds {
    min: number;
    max: number;
}

export function isThreeWheelerVehicle(input: Pick<LorryVehicleRestrictionInput, "totalTyres" | "vehicleCategory">) {
    return input.vehicleCategory === "3WT" || Number(input.totalTyres) === 3;
}

export function isCapacityOutsideAllowedRange(capacity: number, bounds: CapacityBounds) {
    if (!Number.isFinite(capacity) || capacity <= 0) {
        return false;
    }
    if (!bounds.min && !bounds.max) {
        return false;
    }
    return capacity < bounds.min || capacity > bounds.max;
}

export function isLorryCapacityOutsideAllowedRange(capacity: number, bounds?: Partial<CapacityBounds> | null) {
    return isCapacityOutsideAllowedRange(capacity, {
        min: bounds?.min ?? NEW_LORRY_CAPACITY.LORRY_POST.min,
        max: bounds?.max ?? NEW_LORRY_CAPACITY.LORRY_POST.max
    });
}

export function isLoadCapacityOutsideAllowedRange(capacity: number, bounds?: Partial<CapacityBounds> | null) {
    return isCapacityOutsideAllowedRange(capacity, {
        min: bounds?.min ?? NEW_LORRY_CAPACITY.LOAD_POST.min,
        max: bounds?.max ?? NEW_LORRY_CAPACITY.LOAD_POST.max
    });
}

export function getLorryVehicleRestriction(
    input: LorryVehicleRestrictionInput,
    bounds?: Partial<CapacityBounds> | null
): LorryVehicleRestrictionKind | null {
    if (isThreeWheelerVehicle(input)) {
        return "three_wheeler";
    }

    if (isLorryCapacityOutsideAllowedRange(Number(input.capacity), bounds)) {
        return "capacity_out_of_range";
    }

    return null;
}

export function formatLorryCapacityRangeLabel(bounds?: Partial<CapacityBounds> | null) {
    const min = bounds?.min ?? NEW_LORRY_CAPACITY.LORRY_POST.min;
    const max = bounds?.max ?? NEW_LORRY_CAPACITY.LORRY_POST.max;
    return `${min}T - ${max}T`;
}

export function formatLoadCapacityRangeLabel(bounds?: Partial<CapacityBounds> | null) {
    const min = bounds?.min ?? NEW_LORRY_CAPACITY.LOAD_POST.min;
    const max = bounds?.max ?? NEW_LORRY_CAPACITY.LOAD_POST.max;
    return `${min}T - ${max}T`;
}
